import { apiNode } from '../services/api';

interface getSavedSudokuProps {
  userID: number;
  gameID: number;
}

export interface iSquare {
  value: string;
}

export interface iPostSudoku {
  jogos_id: number;
  users_id: number;
  cache: string;
  finished: number;
  pontuacao: number;
  tempo: number;
}

export interface iCell {
  attributes: {
    x: string;
    y: string;
    solution: string;
    hint: string;
  };
}

export interface iBox {
  'box-width': string;
  'box-height': string;
}

export interface iGameSudoku {
  'crossword-compiler': {
    'rectangular-puzzle': {
      attributes: {
        alphabet: string;
      };
      sudoku: {
        attributes: iBox;
        grid: {
          attributes: {
            height: string;
            width: string;
          };
          cell: iCell[];
        };
      };
    };
  };
}

export const getSudoku = async (id: number): Promise<iGameSudoku> => {
  try {
    const response = await apiNode.get(`/show_sudoku/${id}`);

    return JSON.parse(response.data.game);
  } catch (err: unknown) {
    console.log(err);
    throw err;
  }
};

export const getSavedSudoku = async ({
  userID,
  gameID,
}: getSavedSudokuProps): Promise<iPostSudoku[]> => {
  try {
    const response = await apiNode.get(
      `/sudoku_progresso/${userID}?jogos_id=${gameID}}`
    );
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const postSudoku = async (requestBody: iPostSudoku) => {
  try {
    await apiNode.post(`/sudoku_progresso`, requestBody);
  } catch (err) {
    console.log(err);
    throw err;
  }
};
